import React from 'react';
import { mlColor } from '../../helpers';

export default function MLBar({ score }) {
  const n = Math.round(parseFloat(score) || 0);
  const c = mlColor(n);
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
      <div style={{ flex: 1, height: 3, background: 'rgba(0,0,0,0.08)', borderRadius: 1.5, overflow: 'hidden' }}>
        <div style={{ width: `${n}%`, height: '100%', background: c, borderRadius: 1.5, transition: 'width 0.4s' }} />
      </div>
      <span className="mono" style={{ fontSize: 10, fontWeight: 700, minWidth: 24, color: c, textAlign: 'right' }}>{n}</span>
    </div>
  );
}
